var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 200",
    width: 960,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 200,
    fill: "#0A192E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 108L137 105L274 92L411 117L549 108L686 90L823 128L960 115L960 201L823 201L686 201L549 201L411 201L274 201L137 201L0 201Z",
    fill: "#192e3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 127L137 143L274 110L411 120L549 146L686 132L823 140L960 131L960 201L823 201L686 201L549 201L411 201L274 201L137 201L0 201Z",
    fill: "#14202f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 150L137 157L274 161L411 145L549 158L686 164L823 154L960 166L960 201L823 201L686 201L549 201L411 201L274 201L137 201L0 201Z",
    fill: "#0e1421"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 176L137 182L274 178L411 184L549 160L686 184L823 167L960 167L960 201L823 201L686 201L549 201L411 201L274 201L137 201L0 201Z",
    fill: "#000013"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.26811636782f9b9cb8e7b5f1e7fca6f7.svg";
export { ForwardRef as ReactComponent };